var lx = lx || {};

/* Created on 23.10.2019 by Davor */
lx.profile = {
    /*getPic: (pType, pId) => {
        return '<div class="profilePic"><i class="far fawe-'+ (pType == 'FOL' ? 'user-alt' : 'building') +'"></i></div>';
    },*/
    genPic: (options) => {
        if (typeof options == "undefined") return;
        var temp;
        //console.log(options);
        if (options.img){
            temp = '<span class="imgHelper"></span><img src="'+ (options.path ? options.path : '') + options.img +'" />';
        } else if (options.int) {
            temp = '<span class="int">'+ options.int +'</span>';
        } else {
            temp = '<i class="'+ options.fa +'"></i>';
        }
        temp = '<div class="profilePic'+ ( options.size ? ' profilePic__'+ options.size : '' ) +'">'+ temp +'</div>';
        //console.log(temp);
        return temp;
    }
};

lx.profile.status = {
    filter: function (pFolId) {
        var vId = $v("P" + $v("pFlowStepId") + "_ID");
        var lActiveId = document.getElementsByClassName("active")[0].id;
        $(".lxProfilePlug").hide();
        $(".notify-IR").hide();
        lx.load.add();

        apex.server.process("getAjax", {
                x01: 'REPORTS',
                x02: vId,
                x03: ":" +  $v("lxProfReportFilterMonth") + ":" + 
                            $v("lxProfReportFilterYear") + ":" + 
                            $v("lxProfReportFilterMonthHr") + ":" + 
                            $v("lxProfReportFilterYearHr") + ":" + 
                            pFolId,
                x04: $v("lxProfReportFilterFormat")
            },{dataType: 'html'})
            .then(function (data) {
				var TabId = document.getElementsByClassName("active")[0].id;
                plugin_show('B', data, true);
                lx.load.remove();
                change_reports_links(TabId);
            })
            .catch(function (err) {
                console.log(err);
                lx.load.remove();
            });
    },
    eventHours: function (pPage, pOrg, pMonth, pEvType, pYear, pThis) {
        lx.load.add();
        var lPage, lOrg, lMonth, lType, lYear;
        if (pPage == 0) {
            lPage = 1;
            lOrg = pOrg;
            lMonth = pMonth;
            lType = pEvType;
            lYear = pYear;
        } else {
            lPage = pPage;
            lOrg = $v("eventHoursOrgId");
            lMonth = $v("eventHoursMonth");
            lType = $v("eventHoursType");
            lYear = $v("eventHoursYear");
        }

        apex.server.process("getEventHours", {
                x01: lOrg,
                x02: lMonth,
                x03: lType,
                x04: lYear,
                x05: lPage
            },{dataType: 'html'})
            .then(function (d) {
                lx.load.remove();
                if ($(".eventHoursPopup").length == 0)
                    $(d).dialog({
                        modal: true,
                        width: "460px",
                        title: "Events",
                        close: function (event, ui) {
                            $(this).dialog("destroy").remove();
                        }
                    });
                else $(".eventHoursPopup").html($(d).html());
            })
            .catch(function (err) {
                console.log(err);
                lx.load.remove();
            });
    }
};

/* Created on 19.10.2020 by Davor
* balance stripe<>table
*/
lx.profile.balance = {
    viewType: 'I',
    get: function (pType) {
        if (pType) lx.profile.balance.viewType = pType;
        let empId = parseInt($v( ($v("pFlowStepId") == 431 ? "P431_EMP" : "P30_PROFILE_ID_FOL") ));
        if (empId != 0){
            apex.server.process ( "getEmpBalance", {
            x01: empId,
            x02: lx.profile.balance.viewType
            }, {
                type: "GET",
                dataType:'html',
                success: function( pData ) { $("#EmpHrBalance").html(pData).show(); }
            } );
        }else{
            $("#EmpHrBalance").hide();
        }
    },
    toggleTab: function (pSubId, pThis) {
        $container = $(pThis).closest(".ms_activityContainer");
        if ($container.find(".closedInfo").length > 0)  {
           $container.find('#' + pSubId).removeClass('closedInfo');
           $container.find(".ms_activityBox").addClass(pSubId);
           $container.find(".ms_activityBox").css('color','#000');
           $container.find(".fa-info-circle").css('color','#fff');
           $container.find(".ms_activity_icon").removeClass("far fa-angle-down");
           $container.find(".ms_activity_icon").addClass("far fa-angle-up");
          // $("#" + pSubId).hide();
        } else {
           $container.find('#' + pSubId).addClass('closedInfo');      
           $container.find(".ms_activityBox").removeClass(pSubId);
           $container.find(".ms_activityBox").css('color','#333');
           $container.find(".fa-info-circle").css('color','#888');
           $container.find(".ms_activity_icon").removeClass("far fa-angle-up");
           $container.find(".ms_activity_icon").addClass("far fa-angle-down");
              //$("#" + pSubId).show();
        }
    }
};

/* Creted on 29.04.2021 by Davor
*/
lx.profile.selectTab = function (pThis, pColor){
      var tabId = pThis.id, 
        $container = $("#" + tabId + "-container");
    if (!$container.is(":visible")){
        console.log("visible");
        if (tabId == 'lxpTAB-about'){
            lx.load.add;
            apex.server.process ( "getAjax", {
                x01: "ABOUT",
                x02: $v("P" + $v("pFlowStepId") + "_ID"),
                x03: null
                }, {
                    type: "GET",
                    dataType:'html',
                    success: function( pData ) { 
                        lx.load.remove;
                        $container.html(pData).show().siblings(".lxpTAB").hide(); 
                        lx.nav.setTabCurrent(tabId, pColor);
                    }
                } );
        } else {
            $container.show().siblings(".lxpTAB").hide();
            lx.nav.setTabCurrent(tabId, pColor);
        }
    }
};

/* Creted on 29.04.2021 by Davor
*/
lx.profile.activityRows = 1;
lx.profile.activityRow = 0;
lx.profile.canLoad = true;
lx.profile.moreActivity = function (pRn){
    lx.load.add;
    apex.server.process( "moreArticles", {
         x01: lx.profile.activityRow
        },{
         type: "GET",
         dataType: "html",
         success: function (d){
            lx.load.remove;
            lx.profile.activityRow += lx.profile.activityRows;
            $("#lxpTAB-article-container").append(d);
            lx.comment.initAll();
            lx.profile.canLoad = true;
         }
        });
}
lx.profile.initScrollLoad = function (pRow){
    lx.profile.activityRows = pRow;
    lx.profile.activityRow = pRow + 1;
    lx.comment.initAll();
    $(window).scroll(function () {
        if ($(window).scrollTop() + $(window).height() > $(document).height() - 1200 && lx.profile.canLoad) {
            lx.profile.canLoad = false;
            lx.profile.moreActivity();
        }
    });
}

lx.profile.getHpAjax = function (pDest, pFunction, pParam, pThis) {
    var vId = $v("P" + $v("pFlowStepId") + "_ID");
    //alert(pParam);
    lx.load.add;
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getAjax",
            x01: pFunction,
            x02: vId,
            x03: pParam
        },
        success: function (d) {
			console.log(pFunction+"~"+vId+"~"+pParam);
            lx.load.remove;
            if (pDest == "LC") $vObj = $("#LC");
            else $vObj = $("#bottom_list");
            $('.lxHomeProfile').hide();
            /*$(".lxHome").hide();
            $(".lxContent").hide();
            $("#lxCalendar").hide(); // p15
            $("#IR-DIR").hide();  // p54
            $("#facetedSearch").hide(); // p54, p51
            $("#IR-CATALOG").hide();  // p51*/
            $vObj.html(d).show();
			if (pFunction == "REPORTS") {
				$(".profileStripContainer").hide();
				$(".lxHomeRight").hide();
				$(".lxHomepageFeed").hide();
				$(".myStatus").show();
                $("#bottom_list").css("max-width","960px");
				}
			/*if (pFunction == "ABOUT") {lx.nav.setRightCurrent("lxpRM-about"); lx.nav.setTabCurrent("lxpTAB-about");}
			else if (pFunction == "REPORTS") {lx.nav.setRightCurrent("lxpRM-status");}
			else if (pFunction == "ARTICLE") {lx.nav.setRightCurrent("lxpRM-article"); lx.nav.setTabCurrent("lxpTAB-article");}

            if (pFunction == "P_MEMBERS" || pFunction == "list_emps" || pFunction == "list_clients") searchProfileDropdown('bottom_box-profile');
            else if (pFunction == 'P_CONTACT') searchProfileDropdown('bottom_box');*/
        }
    });
};

lx.profile.hideHpAjax = function (){
    $("#bottom_list").hide();
    $(".lxHomeProfile").show();
	$(".profileStripContainer").show();
	$(".myStatus").hide();
}

/*@Martin, getHpAjaxInit checks if About content exists (About and Feed tabs not included, pFunction = 'ABOUT')*/
lx.profile.getHpAjaxInit = function (pDest, pFunction, pParam, pArticle) {
    var vId = $v("P" + $v("pFlowStepId") + "_ID");
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getAjax",
            x01: pFunction,
            x02: vId,
            x03: pParam
        },
        success: function (d) {
            if (pArticle == '') {lx.profile.getHpAjax(pDest,pFunction,pParam);lx.nav.setTabCurrent("lxpTAB-about");}
			else if (pArticle && d.length < 480 ) {lx.profile.getHpAjax(pDest,"ARTICLE",pParam); lx.nav.setTabCurrent("lxpTAB-article");} 
			/*@Martin, 310 is number of generated characters for About and Feed Tabs*/
			else {lx.profile.getHpAjax(pDest,pFunction,pParam); lx.nav.setTabCurrent("lxpTAB-about");}
        }
    });
};

lx.profile.showFeed = function (){
    $("#bottom_list").hide();
    $(".lxHome").show();
    $(".lxContent").show();
};

lx.profile.moreConnections = function (pProfile, pType, pRow, pThis){
    lx.load.add;
    apex.server.process( "moreProfileConnections", {
         x01: pProfile,
         x02: pType,
         x03: pRow
        },{
         type: "GET",
         dataType: "html",
         success: function (d){
            lx.load.remove;
            $(pThis).closest('tr').replaceWith(d);
         }
        });
};

lx.profile.openConnectionTab = function(pThis){
    var $this = $(pThis);
    $this.addClass("a-Tabs-selected is-active").siblings().removeClass("a-Tabs-selected is-active");
    $("#"+ $this.attr("aria-controls")).show().siblings("div").hide();
};

lx.profile.moreBookmarks = function (pType, pRow, pThis){
    lx.load.add;
    apex.server.process( "moreProfileBookmarks", {
         x01: pType,
         x02: pRow
        },{
         type: "GET",
         dataType: "html",
         success: function (d){
            lx.load.remove;
            $(pThis).closest('tr').replaceWith(d);
         }
        });
};

lx.profile.moreEmpSub = function (pId, pRow, pType, pThis){
    lx.load.add;
    apex.server.process( "moreEmpSub", {
         x01: pId,
         x02: pRow,
         x03: pType
        },{
         type: "GET",
         dataType: "html",
         success: function (d){
            lx.load.remove;
            $(pThis).closest('.cnctListRow').replaceWith(d);
         }
        });
};

lx.profile.morePayment = function (pId, pRow, pType){
    lx.load.add;
    apex.server.process( "morePayment", {
         x01: pId,
         x02: pRow,
         x03: pType
        },{
         type: "GET",
         dataType: "html",
         success: function (d){
            lx.load.remove;
			console.log(d);
            $('#lxProfilePay').replaceWith(d);
         }
        });
};

lx.profile.resendConfirmation  = function () {
	apex.server.process("ResendEmailConfirmation", {
              }, {dataType: "text",
                  success: function () {
                      location.reload();
                  }
              });
	
}


var getHpAjax = lx.profile.getHpAjax;